<template>
  <div class="tw-w-full">
    <SfSkeletonLoader
      v-for="(width, index) in SKELETON_WIDTHS"
      :key="index"
      :width="width"
    />
  </div>
</template>

<script setup lang="ts">
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'

const SKELETON_WIDTHS = ['15rem', '20rem', '10rem']
</script>
